import { useState } from 'react';
import { sendFeedback } from '../../../services/api';
import type { FeedbackRating, FeedbackTargetType } from '../../../services/api';

interface FeedbackButtonsProps {
  targetType: FeedbackTargetType;
  targetId: string;
  subject?: string | null;
}

/**
 * Botones 👍/👎 reutilizables. Envían feedback al backend y muestran estado de
 * envío / agradecimiento. Usados en las respuestas del chat (`targetId` = `query_id`).
 */
export default function FeedbackButtons({ targetType, targetId, subject }: FeedbackButtonsProps) {
  const [rating, setRating] = useState<FeedbackRating | null>(null);
  const [sending, setSending] = useState<FeedbackRating | null>(null);
  const [done, setDone] = useState(false);

  const submit = async (value: FeedbackRating) => {
    if (sending || rating) return;
    setSending(value);
    try {
      await sendFeedback({ target_type: targetType, target_id: targetId, rating: value, subject });
      setRating(value);
      setDone(true);
    } catch (err) {
      console.error('Error enviando feedback:', err);
    } finally {
      setSending(null);
    }
  };

  return (
    <div className="feedback-row">
      <span className="feedback-prompt">¿Te ha resultado útil?</span>
      <button
        type="button"
        className={`feedback-btn ${rating === 'up' ? 'active-up' : ''}`}
        onClick={() => submit('up')}
        disabled={Boolean(sending) || Boolean(rating)}
        aria-label="Me ha resultado útil"
        title="Útil"
      >
        {sending === 'up' ? <i className="ri-loader-4-line animate-spin" /> : <i className="ri-thumb-up-line" />}
      </button>
      <button
        type="button"
        className={`feedback-btn ${rating === 'down' ? 'active-down' : ''}`}
        onClick={() => submit('down')}
        disabled={Boolean(sending) || Boolean(rating)}
        aria-label="No me ha resultado útil"
        title="No útil"
      >
        {sending === 'down' ? <i className="ri-loader-4-line animate-spin" /> : <i className="ri-thumb-down-line" />}
      </button>
      {done && <span className="feedback-thanks">Gracias por tu valoración</span>}
    </div>
  );
}
